import { motion } from 'framer-motion'

// Publication logos - these would be replaced with actual logo images
const publications = [
  { name: 'VOGUE', width: 100 },
  { name: 'ELLE', width: 60 },
  { name: 'COSMOPOLITAN', width: 140 },
  { name: 'ALLURE', width: 80 },
  { name: 'BYRDIE', width: 80 },
  { name: 'Forbes', width: 90 },
]

export default function SocialProof() {
  return (
    <section className="py-20 lg:py-24 bg-bg-secondary border-t border-border-subtle">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center text-xs uppercase tracking-[0.3em] text-text-muted mb-12"
        >
          As Seen In
        </motion.p>

        {/* Logos Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 lg:gap-x-20"
        >
          {publications.map((pub, index) => (
            <motion.div
              key={pub.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-text-muted hover:text-text-secondary transition-colors duration-300"
              style={{ width: pub.width }}
            >
              {/* Placeholder text logos - replace with actual logo images */}
              <span
                className="block text-center font-display font-bold tracking-wide"
                style={{
                  fontSize: pub.name === 'COSMOPOLITAN' ? '12px' : '18px',
                  letterSpacing: pub.name === 'COSMOPOLITAN' ? '0.15em' : '0.1em',
                }}
              >
                {pub.name}
              </span>
            </motion.div>
          ))}
        </motion.div>

        {/* Optional: Testimonial Quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-20 text-center max-w-2xl mx-auto"
        >
          <blockquote className="text-xl lg:text-2xl font-serif italic text-text-primary mb-4">
            "The future of beauty tech has arrived. Nakhoons seamlessly blends
            fashion with functionality."
          </blockquote>
          <cite className="text-sm text-text-muted not-italic uppercase tracking-wider">
            — Beauty Tech Review
          </cite>
        </motion.div>
      </div>
    </section>
  )
}
